import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CountryAndRegionsComponent } from './country-and-regions.component';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';


@NgModule({
  declarations: [CountryAndRegionsComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    FGBSharedModule
  ],
  exports: [CountryAndRegionsComponent],
})
export class CountryAndRegionsModule {}
